import {AllMenus} from '../Constants/AllMenus';

// Apps that open inside the dashboard in an iframe live under one prefix, e.g.
// /apps/marketing. Change it here to move every app.
export const APP_ROUTE_PREFIX = '/apps';

// Menu keys that keep a legacy stored name but need a clearer URL.
const APP_SLUG_OVERRIDES = {
  workflow: 'marketing',
};

// Social Connect is now a native page in this dashboard. Keep this override so
// older tenant sidebar records that still contain the former iframe metadata
// cannot send users back to the retired external app.
const MENU_HREF_OVERRIDES = {
  social_connect: '/social',
};

const slugify = value =>
  String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getAppSlug = menu =>
  APP_SLUG_OVERRIDES[menu?.key_name] ||
  slugify(menu?.title) ||
  String(menu?.id ?? '');

export const getAppRoutePath = menu =>
  `${APP_ROUTE_PREFIX}/${getAppSlug(menu)}`;

export const getMenuHref = menu =>
  MENU_HREF_OVERRIDES[menu?.key_name] || menu?.href || '';

export const isIframeAppMenu = menu =>
  menu?.key_name !== 'social_connect' &&
  Boolean(menu?.is_dynamic_side_menu && menu?.is_open_via_iframe_sidepan);

export const findAppMenuBySlug = slug =>
  AllMenus.find(menu => isIframeAppMenu(menu) && getAppSlug(menu) === slug);
